export const API_BASE_URL = "https://www.rwittmer.com/api";
//export const API_BASE_URL = "http://localhost:3366/api";
export const PRIVACY_POLITICS_URL = "https://rolfwittmer-my.sharepoint.com/:b:/g/personal/edison_tiptoptravel_ec/EV762mhMFSpDh-TdoCUY5rQB9lqZsqYWfReBCry-Vp_zhA?e=fXFyuK";
export const SITE_KEY  = "6LcELyIrAAAAAB95O5eEPP_vVaL8xZie3CI4qzML";